import { apiFetch } from "./client";

export function login(email, password) {
  return apiFetch("/api/login", {
    method: "POST",
    body: JSON.stringify({ email, password }),
    token: null,
  });
}

export function register(email, password) {
  return apiFetch("/api/register", {
    method: "POST",
    body: JSON.stringify({ email, password }),
    token: null,
  });
}

export function verifyEmail(email, token, addressId) {
  let url = `/api/verify-email?email=${encodeURIComponent(email)}&token=${encodeURIComponent(token)}`;
  if (addressId) {
    url += `&addressId=${encodeURIComponent(addressId)}`;
  }
  return apiFetch(url, {
    method: "GET",
    token: null,
  });
}

export function forgotPassword(email) {
  return apiFetch("/api/forget-password", {
    method: "POST",
    body: JSON.stringify({ email }),
    token: null,
  });
}

export function resetPassword(email, password, token) {
  return apiFetch("/api/reset-password", {
    method: "POST",
    body: JSON.stringify({ email, password, token }),
    token: null,
  });
}
